import { DecimalPipe } from '@angular/common';
import { inject, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberOrNoop',
  standalone: true,
})
export class NumberOrNoopPipe implements PipeTransform {
  private decimalPipe = inject(DecimalPipe);

  public transform(
    value: string | number,
    applyNumberPipe: boolean,
    format = '1.2-2',
  ) {
    return applyNumberPipe ? this.decimalPipe.transform(value, format) : value;
  }
}
